// extracted by mini-css-extract-plugin
module.exports = {"skelet":"Skelet_skelet__UPSSf","wheeeee":"Skelet_wheeeee__QBGkw","invert":"Skelet_invert__iVQwl"};